/**
 * DG Product Page JS — redesigned to work with pdp-* classes
 * Handles: gallery thumbs, qty stepper, variant selection,
 *          sticky bar visibility, AJAX ATC, favourite toggle.
 */

document.addEventListener('DOMContentLoaded', function () {

    // ── 1. Gallery thumbnails ─────────────────────────────────────────
    var mainImg = document.getElementById('pdp-main-img');
    var thumbBtns = document.querySelectorAll('.pdp-gallery__thumb');

    thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            if (!mainImg) return;
            var newSrc = this.dataset.src;
            var newAlt = this.dataset.alt || '';
            // Crossfade: fade out → swap → fade in
            mainImg.classList.add('is-fading');
            setTimeout(function () {
                mainImg.src = newSrc;
                mainImg.alt = newAlt;
                mainImg.classList.remove('is-fading');
            }, 200);
            thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
            this.classList.add('is-active');
        });
    });

    // ── 2. Cart init for ajax-counter form ───────────────────────────
    // The form uses dg-product-card__add-btn-inline + dg-product-card__counter
    // Handled globally by dg.js click delegation — we only need to init state.
    var pdpAjaxForm = document.getElementById('pdp-ajax-form');
    if (pdpAjaxForm && window.DG_cartItems) {
        if (typeof window.syncCardState === 'function') window.syncCardState(pdpAjaxForm);
    }

    // ── 3. Variant selection ──────────────────────────────────────────
    var variantCards = document.querySelectorAll('.pdp-variant-card');
    var hiddenId = document.getElementById('pdp-variant-id');

    // Helper: format money (cents → "$X.XX")
    function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    variantCards.forEach(function (card) {
        card.addEventListener('click', function () {
            var variantId = this.dataset.variantId;
            if (!variantId) return;

            // Active class
            variantCards.forEach(function (c) { c.classList.remove('is-active'); });
            this.classList.add('is-active');

            // Sync hidden form ID inputs
            document.querySelectorAll('input[name="id"]').forEach(function (inp) {
                inp.value = variantId;
            });

            // Update URL
            if (history.pushState) {
                var url = new URL(window.location);
                url.searchParams.set('variant', variantId);
                history.pushState({}, '', url);
            }

            if (typeof window.dgRefreshPdpUnitPrice === 'function') {
                var unitEl = document.getElementById('pdp-unit-price');
                if (unitEl && this.dataset.wcpPriceCents) {
                    unitEl.dataset.wcpPriceCents = this.dataset.wcpPriceCents;
                }
                window.dgRefreshPdpUnitPrice();
                setTimeout(window.dgRefreshPdpUnitPrice, 400);
                setTimeout(window.dgRefreshPdpUnitPrice, 2000);
            }

            // Fetch variant data and update price/availability
            fetch('/products/' + window.pdpProductHandle + '.js')
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    var variant = data.variants.find(function (v) { return String(v.id) === String(variantId); });
                    if (!variant) return;

                    // Price
                    var priceBlock = document.querySelector('.pdp-price-block');
                    if (priceBlock) { 

                        var compareEl = priceBlock.querySelector('.pdp-price__compare');
                        var mainEl = priceBlock.querySelector('.pdp-price__main');
                         
                        if (mainEl) {
                            mainEl.textContent = formatMoney(variant.price);
                            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                                mainEl.classList.add('pdp-price__main--sale');
                            } else {
                                mainEl.classList.remove('pdp-price__main--sale');
                            }
                            try{
                                mainEl.classList.remove("wpd-processed");
                                mainEl.setAttribute("data-wpd-variant-compare-at-price",variant.compare_at_price == null?"":variant.compare_at_price);
                                mainEl.setAttribute("data-wpd-variant-price",variant.price);
                                mainEl.setAttribute("data-wpd-variant-id",variant.id);
                                mainEl.setAttribute("data-wpd-product-handle", document.querySelector("#wpdproduct-modal").value);
                                if (typeof window.dgRefreshPdpUnitPrice === 'function') {
                                    setTimeout(window.dgRefreshPdpUnitPrice, 400);
                                    setTimeout(window.dgRefreshPdpUnitPrice, 1500);
                                }
                                }catch(e){}
                        }
                        if (compareEl) {
                            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                                compareEl.textContent = formatMoney(variant.compare_at_price);
                                compareEl.style.display = '';
                            } else {
                                compareEl.style.display = 'none';
                            }
                        }
                        
                    }

                    // Expiration date
                    var expiryEl = document.getElementById('pdp-price-expire');
                    if (expiryEl) {
                        var expiryDateStr = card.dataset.expiry || '';
                        if (expiryDateStr && variant.compare_at_price && variant.compare_at_price > variant.price) {
                            expiryEl.innerHTML = expiryDateStr;
                            expiryEl.style.display = '';
                        } else {
                            expiryEl.style.display = 'none';
                        }
                    }

                    // Sticky bar price
                    var stickyPrice = document.querySelector('.pdp-sticky-bar__price');
                    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

                    // Availability
                    var avail = document.querySelector('.pdp-availability');
                    if (avail) {
                        var availLabel = variant.available ? 'En stock' : 'Rupture de stock';
                        if (variant.available) {
                            avail.className = 'pdp-availability pdp-availability--in';
                        } else {
                            avail.className = 'pdp-availability pdp-availability--out';
                        }
                        var textNode = Array.prototype.find.call(avail.childNodes, function (n) {
                            return n.nodeType === 3;
                        });
                        if (textNode) {
                            textNode.textContent = availLabel;
                        } else {
                            avail.appendChild(document.createTextNode(availLabel));
                        }
                    }
                    var pdpBanner = document.querySelector('[data-dg-backorder-banner]');
                    if (pdpBanner) {
                        var showPdpBanner = variant.inventory_management === 'shopify'
                            && variant.inventory_quantity <= 0;
                        pdpBanner.hidden = !showPdpBanner;
                    }

                    // Sync ajax-counter form for new variant
                    if (pdpAjaxForm && typeof window.syncCardState === 'function') {
                        window.syncCardState(pdpAjaxForm);
                    }
                    // Update inventory data for backorder warning
                    if (pdpAjaxForm && variant.inventory_quantity !== undefined) {
                        pdpAjaxForm.dataset.inventoryQty = Math.max(variant.inventory_quantity, 0);
                        if (typeof window.updateBackorderWarning === 'function') window.updateBackorderWarning(pdpAjaxForm);
                    }
                    // Update add-btn text availability
                    var pdpAddBtn = pdpAjaxForm && pdpAjaxForm.querySelector('.dg-product-card__add-btn-inline');
                    if (pdpAddBtn) {
                        pdpAddBtn.disabled = !variant.available;
                        var btnTextSpan = pdpAddBtn.querySelector('.dg-btn-text');
                        if (btnTextSpan) {
                            btnTextSpan.textContent = variant.available ? 'Ajouter' : 'Épuisé';
                        }
                    }

                    // SKU / Code Réf
                    var skuEl = document.getElementById('pdp-sku');
                    if (skuEl) {
                        skuEl.textContent = 'Réf: #' + (variant.sku || '');
                    }
                })
                .catch(function () { });
        });
    });

    // ── 4. Sticky ATC bar visibility ─────────────────────────────────
    var stickyBar = document.getElementById('pdp-sticky-bar');
    var mainAtcBtn = document.querySelector('.pdp-atc-btn');

    if (stickyBar && mainAtcBtn) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                    stickyBar.classList.add('is-visible');
                    stickyBar.removeAttribute('aria-hidden');
                } else {
                    stickyBar.classList.remove('is-visible');
                    stickyBar.setAttribute('aria-hidden', 'true');
                }
            });
        }, { threshold: 0 });
        observer.observe(mainAtcBtn);
    }

    // ── 5. AJAX Add to Cart (main form) ──────────────────────────────
    var pdpForm = document.getElementById('pdp-form');
    var stickyAtcBtn = document.querySelector('.pdp-sticky-atc-btn');

    if (pdpForm) {
        // Allow sticky button to trigger form submission
        if (stickyAtcBtn) {
            stickyAtcBtn.addEventListener('click', function (e) {
                e.preventDefault();
                pdpForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            });
        }

        pdpForm.addEventListener('submit', function (e) {
            e.preventDefault();

            var btn = pdpForm.querySelector('.pdp-atc-btn');

            var originalText = btn ? btn.textContent.trim() : '';
            var originalStickyText = stickyAtcBtn ? stickyAtcBtn.textContent.trim() : '';

            if (btn) {
                btn.disabled = true;
                btn.textContent = '…';
            }
            if (stickyAtcBtn) {
                stickyAtcBtn.disabled = true;
                stickyAtcBtn.textContent = '…';
            }

            // Payload: variant id + quantity only
            var variantId = (pdpForm.querySelector('input[name="id"]') || {}).value;
            var qtyInput = pdpForm.querySelector('input[name="quantity"]');
            var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

            if (!variantId) {
                console.error('[DG PDP] No variant ID found');
                if (btn) { btn.disabled = false; btn.textContent = originalText; }
                if (stickyAtcBtn) { stickyAtcBtn.disabled = false; stickyAtcBtn.textContent = originalStickyText; }
                return;
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: quantity })
            })
                .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
                .then(function (res) {
                    if (!res.ok || res.data.status) {
                        console.error('[DG PDP] ATC error:', res.data.description || res.data.message || JSON.stringify(res.data));
                        if (btn) { btn.disabled = false; btn.textContent = originalText; }
                        if (stickyAtcBtn) { stickyAtcBtn.disabled = false; stickyAtcBtn.textContent = originalStickyText; }
                        return;
                    }

                    // ── Same pipeline as product cards ──────────────────
                    // 1. Reload drawer HTML (Shopify Sections API) then open it
                    if (typeof window.updateCartDrawer === 'function') {
                        window.updateCartDrawer();
                    }
                    if (typeof window.openCartDrawer === 'function') {
                        // Small delay so updateCartDrawer finishes injecting HTML first
                        setTimeout(window.openCartDrawer, 120);
                    }

                    // 2. Sync header badge + bottom-nav badge
                    if (typeof window.refreshCartState === 'function') {
                        window.refreshCartState();
                    }

                    // 3. Broadcast for any other listeners
                    document.dispatchEvent(new CustomEvent('dg:cart:updated', { detail: { item: res.data } }));

                    // 4. Flash success on button
                    if (btn) {
                        btn.textContent = '✓ Ajouté';
                        btn.style.background = 'var(--dg-success, #22c55e)';
                    }
                    if (stickyAtcBtn) {
                        stickyAtcBtn.textContent = '✓ Ajouté';
                        stickyAtcBtn.style.background = 'var(--dg-success, #22c55e)';
                    }

                    setTimeout(function () {
                        if (btn) {
                            btn.disabled = false;
                            btn.textContent = originalText;
                            btn.style.background = '';
                        }
                        if (stickyAtcBtn) {
                            stickyAtcBtn.disabled = false;
                            stickyAtcBtn.textContent = originalStickyText;
                            stickyAtcBtn.style.background = '';
                        }
                    }, 1800);
                })
                .catch(function (err) {
                    console.error('[DG PDP] ATC fetch error:', err);
                    if (btn) { btn.disabled = false; btn.textContent = originalText; }
                    if (stickyAtcBtn) { stickyAtcBtn.disabled = false; stickyAtcBtn.textContent = originalStickyText; }
                });
        });
    }


    // ── 6. Favourite toggle ───────────────────────────────────────────
    var favBtn = document.getElementById('pdp-fav-btn');
    if (favBtn) {
        var favHandle = favBtn.dataset.handle || window.pdpProductHandle || '';
        var favLabel = favBtn.querySelector('span');

        /**
         * A favorite is VARIANT-level, so the button must read the variant the
         * customer is looking at RIGHT NOW — the same `input[name="id"]` the
         * variant picker rewrites and Add-to-cart submits. Reading the frozen
         * `data-handle` would save whichever format happened to load first.
         */
        function favKeyCourante() {
            var inp = document.querySelector('.pdp-form input[name="id"]')
                || document.querySelector('input[name="id"]');
            var vid = inp && inp.value;
            if (vid) return 'v:' + vid;
            return favHandle || null;
        }

        function favMetaCourante() {
            var sel = document.querySelector('.pdp-variant-option.is-selected, [data-variant-id].is-selected');
            return {
                h: favHandle,
                s: (sel && sel.dataset.sku) || '',
                t: (document.querySelector('.pdp-title') || {}).textContent || favHandle,
                u: null
            };
        }

        function updateFavUI(isActive) {
            favBtn.classList.toggle('is-active', isActive);
            if (favLabel) {
                favLabel.textContent = isActive ? 'Dans vos favoris' : 'Ajouter aux favoris';
            }
        }

        function refreshFavUI() {
            var key = favKeyCourante();
            if (window.dgFav && key) updateFavUI(window.dgFav.has(key));
        }

        refreshFavUI();
        // Le sélecteur de format réécrit input[name="id"] : le cœur doit suivre.
        document.querySelectorAll('[data-variant-id]').forEach(function (el) {
            el.addEventListener('click', function () { setTimeout(refreshFavUI, 0); });
        });

        favBtn.addEventListener('click', function () {
            var key = favKeyCourante();
            if (window.dgFav && key) {
                var nowActive = window.dgFav.toggle(key, favMetaCourante());
                updateFavUI(nowActive);
            } else {
                // Fallback: visual only
                var active = favBtn.classList.toggle('is-active');
                if (favLabel) favLabel.textContent = active ? 'Dans vos favoris' : 'Ajouter aux favoris';
            }
        });
    }

    // ── 7. Scroll Reveal Animation ────────────────────────────────────
    var revealEls = document.querySelectorAll('.pdp-reveal');
    if (revealEls.length && 'IntersectionObserver' in window) {
        var revealObs = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-revealed');
                    revealObs.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

        revealEls.forEach(function (el, i) {
            el.style.animationDelay = (i * 0.08) + 's';
            revealObs.observe(el);
        });
    } else {
        // Fallback: show immediately
        revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
    }

    // ── 8. Accordion auto-scroll into view on open ───────────────────
    var accordions = document.querySelectorAll('.pdp-accordion');
    accordions.forEach(function (details) {
        details.addEventListener('toggle', function () {
            if (this.open) {
                var self = this;
                // Small delay so content renders before we measure
                setTimeout(function () {
                    var rect = self.getBoundingClientRect();
                    var bottomVisible = rect.bottom <= window.innerHeight;
                    if (!bottomVisible) {
                        self.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                }, 50);
            }
        });
    });

});

// Expose product handle for variant fetch (set via Liquid if needed)
// window.pdpProductHandle is expected to be set in main-product-dg.liquid
// or falls back to pathname:
window.pdpProductHandle = window.pdpProductHandle ||
    (function () {
        var parts = window.location.pathname.split('/products/');
        return parts.length > 1 ? parts[1].split('?')[0].split('/')[0] : '';
    })();
